module.exports = "/img/rapbeat_sponsor.png?907d333ca2d85d01477fafc98f9c3b27";